import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Router, Route, Switch, Redirect } from 'react-router-dom';
import TopMenu from './components/TopMenu';
import Courses from './components/Courses';
import Default from './components/Default';
import SignIn from './components/SignIn';
import Settings from './components/Settings';
import P404 from './components/P404';
import { baseUrl } from './config';
import Messages from './components/Messages';
import Developer from './components/Developer';
import { authInit } from './redux/actions';
import Course from './components/Course'
import history from './history';
import analytics from './analytics';
import Dialogs from './components/Dialogs';
import {
  subscribeKeyboard,
  unsubscribeKeyboard,
} from './redux/actions';

analytics(history);
const isDevelopment = process.env.NODE_ENV === 'development';

function Loading(props) {
  useEffect(() => {
    props.authInit();
    // eslint-disable-next-line
  }, []);
  return <p style={{ padding: 10 }}>Łączę z serwerem ...</p>;
}

const RestrictedArea = connect(null, { authInit })(Loading);

function Routes(props) {
  const { auth, userState, config, messages } = props;

  useEffect(() => {
    props.subscribeKeyboard();
    return () => {
      props.unsubscribeKeyboard();
    }
    // elint-disable-next-line
  }, []);

  const renderLogin = () => {
    return (
      <Router history={history} basename={baseUrl}>
        {!!messages && <Messages />}
        <TopMenu />
        <Switch>
          <Route path='/login' component={SignIn} />
          <Route component={RestrictedArea} />
        </Switch>
      </Router>
    )
  }

  const renderApp = () => {
    return (
      <Router history={history} basename={baseUrl}>
        {!!messages && <Messages />}
        <TopMenu />
        <Switch>
          <Route path='/' exact component={Default} />
          <Route path='/login' component={SignIn} />
          {isDevelopment && <Route path='/developer' component={Developer} />}
          {/* <Route path='/developer' component={Developer} /> */}
          <Route path='/kursy' exact component={Courses} />
          <Route path='/kurs/' exact>
            <Redirect to='/kursy/' />
          </Route>
          <Route path='/kurs/:course' exact>
            <Redirect to='/' />
          </Route>
          <Route path='/kurs/:course/:tab/:unit?/:exercise?' component={Course} />
          <Route path='/ustawienia' component={Settings} />
          <Route component={P404} />
        </Switch>
        <Dialogs />
      </Router>
    );
  }

  return (auth.loggedIn === false || !userState.loaded || !config.loaded) ? renderLogin() : renderApp();
}

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    userState: state.userState,
    config: state.config,
    messages: state.messages.length,
  }
}

export default connect(mapStateToProps, {
  subscribeKeyboard,
  unsubscribeKeyboard,
})(Routes);